module.exports = __webpack_public_path__ + "img/2.e6cace4d.png";